import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, TableCell, Icon } from '@material-ui/core';
import { showMessage } from 'app/store/fuse/messageSlice';
import OptimizerLogRunsAndTrajectoriesDialog from './OptimizerLogRunsAndTrajectoriesDialog';

function OptimizerLogRunsAndTrajectoriesButton(props) {
    const [openDialog, setOpenDialog] = useState(false);

    const dispatch = useDispatch();

    return (
        <TableCell className='w-auto text-center' padding='none'>

            <Tooltip title='Export'>
                <span>
                    <IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}>
                        <Icon fontSize="small">download</Icon>
                    </IconButton>
                </span>
            </Tooltip>

            {openDialog && (
                <OptimizerLogRunsAndTrajectoriesDialog
                    name={props.item.name}
                    onCancel={() => setOpenDialog(false)}
                    onSave={result => {
                        // onChange(result);
                        setOpenDialog(false);
                    }}
                />
            )}

        </TableCell>
    );
}

export default OptimizerLogRunsAndTrajectoriesButton;